module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-large.33493a3c.jpg";